export const CHANGE_THEME = 'CHANGE_THEME';
export const TOGGLE_SUMMARY = 'TOGGLE_SUMMARY';

/**
 * Change current theme path
 */
export function changeTheme(path:any) {
  return { type: CHANGE_THEME, path } as any;
}
